
export type StrictOrderAlignment = "Lawful" | "Neutral" | "Chaotic";
export type OrderAlignment = StrictOrderAlignment | "Non-Lawful" | "Non-Neutral" | "Non-Chaotic" | "Any" | "Unaligned";
export type StrictMoralAlignment = "Good" | "Neutral" | "Evil"; 
export type MoralAlignment = StrictMoralAlignment | "Non-Good" | "Non-Neutral" | "Non-Evil" | "Any" | "Unaligned";

export const isStrictOrderAlignment = (str: string): str is StrictOrderAlignment => {
  return str === "Lawful" ||
    str === "Neutral" ||
    str === "Chaotic";
}
export const isOrderAlignment = (str: string): str is OrderAlignment => {
  return isStrictOrderAlignment(str) || 
    str === "Non-Lawful" ||
    str === "Non-Neutral" ||
    str === "Non-Chaotic" ||
    str === "Any" ||
    str === "Unaligned";
}

export const isStrictMoralAlignment = (str: string): str is StrictMoralAlignment => {
  return str === "Good" ||
    str === "Neutral" ||
    str === "Evil";
}
export const isMoralAlignment = (str: string): str is MoralAlignment => {
  return isStrictMoralAlignment(str) || 
    str === "Non-Good" ||
    str === "Non-Neutral" ||
    str === "Non-Evil" ||
    str === "Any" ||
    str === "Unaligned";
}

export const STRICT_ORDER_ALIGNMENTS = ["Lawful","Neutral","Chaotic"];
export const ORDER_ALIGNMENTS = [...STRICT_ORDER_ALIGNMENTS,"Non-Lawful","Non-Neutral","Non-Chaotic","Any","Unaligned"];
export const STRICT_MORAL_ALIGNMENTS = ["Good","Neutral","Evil"]; 
export const MORAL_ALIGNMENTS = [...STRICT_MORAL_ALIGNMENTS,"Non-Good","Non-Neutral","Non-Evil","Any","Unaligned"];

export interface Alignment {
  order: OrderAlignment;
  moral: MoralAlignment;
}

export const alignmentString = (alignment: Alignment) => {
  if (isStrictOrderAlignment(alignment.order) && isStrictMoralAlignment(alignment.moral)) {
    if (alignment.order === alignment.moral) {
      return "N";
    } else {
      return `${alignment.order[0]}${alignment.moral[0]}`;
    }
  } else {
    if (alignment.order === alignment.moral) {
      return alignment.order;
    } else {
      return `${alignment.order} ${alignment.moral}`;
    }
  }
}
